var map = {
	"./Auth/Login/Locales/en.json": 1603,
	"./Auth/Login/Locales/pt-br.json": 2182,
	"./Auth/RecoverPassword/Locales/en.json": 6603,
	"./Auth/RecoverPassword/Locales/pt-br.json": 2730,
	"./Auth/ResetPassword/Locales/en.json": 1071,
	"./Auth/ResetPassword/Locales/pt-br.json": 8359,
	"./Company/Locales/en.json": 9585,
	"./Company/Locales/pt-br.json": 6930,
	"./Company/Registers/Departments/Locales/pt-br.json": 6003,
	"./Company/Registers/Units/Locales/pt-br.json": 1270
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1494;